import React, { createContext, useState, useContext } from 'react';
import { APIContext } from '../../../../context/';
import {  Button } from '@material-ui/core';
import CustomToolbar from '../../../customToolbar';
import ClienteDialogForm from '../../../forms/clienteForm';
import AddIcon from "@material-ui/icons/Add";

export const ClientesContext = createContext();

const ClientesProvider = (props) => {

    const ruta_existe = `cotizacion/search?cli_id`;

    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({
        cli_nombre: "",
        cli_tipide: 0,
        cli_numide: "",
        ciu_id: 0,
        cli_email: "",
        cli_telefono: "",
        cli_celular: "",
        cli_direccion: "",
        cli_estado: 0,

    });
    const [editableObject, seteditableObject] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const { clientes, unCheck,verificar_borrar,deleteCliente,
    } = useContext(APIContext);

    const headCells = [
        // Toma, tipo, pasajeros, cilindrada, combustible
        { id: 'cli_id', numeric: true, disablePadding: false, label: '#' },
        { id: 'cli_nombre', numeric: false, disablePadding: false, label: 'Nombre' },
        { id: 'cli_tipide_nom', numeric: true, disablePadding: false, label: 'Tipo de identificación' },
        { id: 'cli_numide', numeric: false, disablePadding: false, label: 'Número de identificación' },
        { id: 'ciu_id', numeric: true, disablePadding: false, label: 'Ciudad' },
        { id: 'cli_email', numeric: false, disablePadding: false, label: 'Email' },
        { id: 'cli_telefono', numeric: false, disablePadding: false, label: 'Teléfono' },
        { id: 'cli_celular', numeric: false, disablePadding: false, label: 'Celular' },
        { id: 'cli_direccion', numeric: false, disablePadding: false, label: 'Dirección' },
        { id: 'cli_estado_nom', numeric: true, disablePadding: false, label: 'Estado' },

    ];

    const idName = "cli_id";

    const data = clientes

    const tipo_ide = [
        { value: 1, tipo: "Cédula" },
        { value: 2, tipo: "RUC" },
        { value: 3, tipo: "Pasaporte" }
    ]

    const estado = [
        { value: 1, tipo: "Activo" },
        { value: 2, tipo: "Inactivo" },
    ]

    const columns = [
        //{ name: "cli_id", label: "Id" },
        { name: "cli_nombre", label: "Nombre" },
        { name: "cli_tipide_nom", label: "T. Id" },
        { name: "cli_numide", label: "Numero Id" },
        { name: "cli_email", label: "Email" },
        { name: "cli_telefono", label: "Telefono" },
        { name: "cli_celular", label: "Celular" },
        { name: "cli_direccion", label: "Dirección" },
        { name: "cli_estado_nom", label: "Estado" },
        {
          name: "",
          options: {
    
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
              const data = clientes[dataIndex];
    
              return (
                <>
                  <Button variant="outlined" color="primary"
                    onClick={(e) => {
                      seteditableObject(data);
                      handleDialogOpen();
                    }}>
                    Ver
                  </Button>
                </>
              );
            }
          }
        }
    
      ];
     
    const options = {
        filter: true,
        filterType: "multiselect",
        textLabels: {
            body: {
            noMatch: "Sorry, no matching records found",
            toolTip: "Sort",
            columnHeaderTooltip: column => `Sort for ${column.label}`
            },
            pagination: {
            next: "Siguiente",
            previous: "Anterior",
            rowsPerPage: "Registros por página:",
            displayRows: "de",
            },
            toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "ver Columnas",
            filterTable: "Filtrar Tabla",
            },
            filter: {
            all: "TODOS",
            title: "FILTROS",
            reset: "RESTABLECER",
            },
            viewColumns: {
            title: "Mostrar Columnas",
            titleAria: "Mostrar/Ocultar Columnas",
            },
            selectedRows: {
            text: "Registro(s) seleccionados",
            delete: "Eliminar",
            deleteAria: "Eliminar Registro(s) seleccionados",
            },
        },
        onRowsDelete:(rowsDeleted) => {
            const array = rowsDeleted.data
            const DeleteId = array.map((arr,index)=>{
                return clientes[arr.dataIndex].cli_id
            })

            array.map((arr,index)=>{
                let id     = clientes[arr.dataIndex].cli_id
                let nombre = clientes[arr.dataIndex].cli_nombre
                verificar_borrar(ruta_existe, id, nombre, DeleteId)
                .then(function(result) {
                    if(result){
                        deleteCliente(id, nombre, DeleteId); 
                    }
                });
                return arr
            })
            unCheck();
            return false
        },
        customToolbar: () => {
        return (
            <CustomToolbar Component={ClienteDialogForm} CustomIcon={AddIcon} />
        );
        },
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false)
    }

    const clearForm = () => {
        setForm({
            cli_nombre: "",
            cli_tipide: 0,
            cli_numide: "",
            ciu_id: 0,
            cli_email: "",
            cli_telefono: "",
            cli_celular: "",
            cli_direccion: "",
            cli_estado: 0,
        })
    }

    return (
        <ClientesContext.Provider
            value={{
                form,
                open,
                headCells,
                idName,
                columns,
                options,
                data,
                dialogOpen,
                editableObject,
                tipo_ide,
                estado,

                clearForm,
                setOpen,
                handleDialogOpen,
                handleDialogClose,
            }}
        >
            {props.children}
        </ClientesContext.Provider>
    );
}

export default ClientesProvider;